import { createSlice } from '@reduxjs/toolkit'

export const incomeSlice = createSlice({
  name: 'income',
  initialState: {
    incomeRecords: [{
      description: '',
      company: '',
      monthlyAmount: 0,
      weeklyAmount: 0,
    }],
    incomeDescriptions: [
      { 'label': 'Full-time Employment', 'value': 'full-time employment' },
      { 'label': 'Part-time Employment', 'value': 'part-time employment' }
    ],
    monthlyTotal: 0,
    weeklyTotal: 0,
  },
  reducers: {
    add: (state, action) => {
      debugger;
      const values = [
      ...state.incomeRecords.slice(0, action.payload),
        {
          description: '',
          company: '',
          monthlyAmount: 0,
          weeklyAmount: 0,
        },
      ...state.incomeRecords.slice(action.payload)
      ]
      state.incomeRecords = values
    },
    remove: (state, action) => {
      if (state.incomeRecords.length > 1) {
        const values = [
          ...state.incomeRecords
        ]
        values.splice(action.payload, 1)
        state.incomeRecords = values
      }
    },
    updateText: (state, action) => {
      const values = [...state.incomeRecords];
      values[action.payload.index][action.payload.event.target.name] = action.payload.event.target.value;
      state.incomeRecords = values;
    },
    updateNumber: (state, action) => {    
      let value = action.payload.value           
      const values = [...state.incomeRecords];
      values[action.payload.index][action.payload.name] = value;
      state.incomeRecords = values;
    }
  }
})

export const { add, remove, updateText, updateNumber } = incomeSlice.actions

export default incomeSlice.reducer